import { useEffect, useState } from "react";

/** Re-renders every `ms` so relative times ("2s ago") stay fresh. */
export default function useNow(ms = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}
